module.exports = __webpack_public_path__ + "static/bricolage-grotesque-500-800-latin-c47ac31e5437a2a864c0aec1b2d611c0.woff2";